webpackJsonp([162898551421021],{

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "container is-fluid" },
	    _react2.default.createElement(
	      "article",
	      { className: "tile is-child", style: { paddingTop: '10rem' } },
	      _react2.default.createElement(
	        "p",
	        { className: "home-title has-text-centered", style: { marginBottom: '2rem' } },
	        "NOT FOUND"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "subtitle has-text-centered is-size-4 m-text-white" },
	        "You just hit a route that doesn't exist... the sadness."
	      )
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-35679575d79bb80da584.js